import React__default, { useEffect } from 'react';
import '../../core/enums/GameSpecificTypes.js';
import '../../core/enums/Chat.js';
import '../../core/enums/GameModes.js';
import '../../core/enums/IconTypes.js';
import '../../core/enums/BetStatus.js';
import '../../core/enums/PopupTypes.js';
import '../../core/enums/ApiVersion.js';
import '../../core/enums/RoundStatus.js';
import '../../core/enums/RequestStatus.js';
import '../../core/enums/FreeBetsStatus.js';
import '../../core/enums/SocketEvents.js';
import '../../core/enums/TranslationKeys.js';
import '../../core/enums/ApiServiceTypes.js';
import '../../core/enums/EnvironmentTypes.js';
import '../../core/enums/DefaultQueryParams.js';
import '../../core/enums/BetHistoryFilterTypes.js';
import '../../core/enums/GameThemeTypes.js';
import '../../core/enums/FetchDefaultPaths.js';
import '../../core/enums/ResponseCodes.js';
import '../../../moment-27179cac.js';
import { l as applicationStore, i as iframeService } from '../../../TranslationService-32200248.js';
import '../../core/services/liveConnection/types.js';
import 'axios';
import '../../core/services/sound/types.js';
import '../../core/services/sound/SoundService.js';
import '../../core/services/sound/defaultSounds.js';
import '../../core/services/api/types.js';
import '../../core/services/ApiServices.js';
import '../../core/store/lobbyStore.js';
import '../../core/store/roundInfoStore.js';
import '../../core/store/userCountStore.js';
import '../../core/store/gameResultStore.js';
import '../../core/store/gameConfigStore.js';
import '../../core/store/resultHashStore.js';
import '../../core/store/userWinBetsStore.js';
import '../../core/store/userSettingsStore.js';
import '../../core/store/notificationStore.js';
import '../../core/store/selectedResultInfoStore.js';
import '../../core/store/chatStore.js';
import '../../core/polyfill.js';
import { observer } from 'mobx-react-lite';
import '../../../_commonjsHelpers-4c2b67c2.js';
import '../../../tslib.es6-80f01feb.js';
import 'mobx';
import '../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../core/services/api/BaseApiService.js';
import '../../core/helpers/environmentBuilder.js';
import '../../core/enums/StatisticsSortingTypes.js';
import '../../core/helpers/parseQuery.js';
import '../../core/helpers/momentFormat.js';
import '../../../table-line/t_types/enums/PopupTypes.js';
import '../../core/helpers/parseNumberByPrecision.js';
import 'howler';

var PlatformMessagesWrapper = observer(function (_a) {
    var children = _a.children, _b = _a.additionalMessagesParams, additionalMessagesParams = _b === void 0 ? [] : _b, isBetShop = _a.isBetShop;
    var isAuthDataReceived = applicationStore.isAuthDataReceived;
    useEffect(function () {
        if (!isBetShop) {
            iframeService.setPostMessageListener(additionalMessagesParams);
            iframeService.sendGetAuthInfo();
        }
    }, [isBetShop]);
    return isBetShop || isAuthDataReceived ? children : React__default.createElement(React__default.Fragment, null);
});

export { PlatformMessagesWrapper };
